import React from 'react';
import GiftOccasion from '../GiftOccasion';
import GiftKlydoGreet from '../GiftKlydoGreet';
import GiftViewContainer from '../GiftViewContainer';
import GiftFormContainer from '../GiftFormContainer';
import { WizardStep } from '../../../consts/wizardSteps';

export type Step = {
  id: string;
  title?: string;
  description?: string;
  component: React.JSX.Element;
};

const steps: Step[] = [
  {
    id: WizardStep.OCCASION,
    title: "What's the occasion?",
    description: "Choose the event that's about to get even more memorable.",
    component: <GiftOccasion />,
  },
  {
    id: WizardStep.GREET,
    title: 'Choose your KlydoGreet',
    description:
      'Pick the perfect animated greeting to surprise your gift recipient the moment they open their Klydoclock.',
    component: <GiftKlydoGreet />,
  },
  {
    id: WizardStep.PERSONAL_GREET,
    title: 'Your personal greeting',
    description:
      'Add a personal message to make your KlydoGreet even more special.',
    component: <GiftFormContainer />,
  },
  {
    id: WizardStep.PREVIEW,
    title: 'Your KlydoGreet is ready!',
    description:
      "Here's a preview of your KlydoGreet, looks great! Proceed to the next step to complete your gift order.",
    component: <GiftViewContainer />,
  },
];

export default steps;
